import React from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { postEntityChangeStatus } from '../../api';
import { formatNumber } from '../../commons';

import { useMigrationEntityStatus, useMigrationSummary } from '../../hooks';

import urlRoutes from '../../config/url-routes';

const StatusCheckIcon = ({ isApproved }) => (
  <svg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='12' cy='12' r='10' fill={isApproved ? '#EDFAF3' : '#F2F2F2'} stroke={isApproved ? '#1DB866' : '#B8B8B8'} strokeWidth='2'/>
    {isApproved && (
      <path d='M8 12L10.5 15L16 9' stroke='#1DB866' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'/>
    )}
  </svg>
);

const Breadcrumbs = () => {
  const { push } = useHistory();
  const { migrationId } = useParams();

  const { loading, data, requestError } = useMigrationSummary(migrationId);
  const { envEntityStatus, setStateChangeEntityStatus } = useMigrationEntityStatus(migrationId);

  const handlerPost = ({ migrationId, entity, status }) => {
    setStateChangeEntityStatus({ entity, status });

    postEntityChangeStatus({
      entity,
      status,
      migrationId,
    });
  }

  const redirect = (url) => push(url.replace(/:migrationId/gi, migrationId));

  const listOptions = () => {
    return [
      {
        entity: 'brokers',
        label: 'Usuários',
        url: urlRoutes.usersUrl,
        total: data.brokers?.total,
        isApproved: envEntityStatus.brokers,
      },
      {
        entity: 'customers',
        label: 'Clientes',
        url: urlRoutes.customersUrl,
        total: data.customers?.total,
        isApproved: envEntityStatus.customers,
      },
      {
        entity: 'properties',
        label: 'Imóveis',
        url: urlRoutes.propertiesUrl,
        total: data.properties?.total,
        isApproved: envEntityStatus.properties,
      },
      {
        entity: 'enterprises',
        label: 'Empreend.',
        url: urlRoutes.enterprisesUrl,
        total: data.enterprises?.total,
        isApproved: envEntityStatus.enterprises,
      },
    ]
  }

  if(requestError) return null;

  return (
    <div className='breadcrumbs'>
      {listOptions().map((item, index) => (
        <div key={index} className='breadcrumb-card'>
          <div className='breadcrumb-card__content'>
            <div className='breadcrumb-card__number'>
              {loading ? (
                <div className='breadcrumb-card__loading' />
              ) : (
                formatNumber(item.total)
              )}
            </div>

            <button
              className='breadcrumb-card__label'
              onClick={() => redirect(item.url)}
              title={item.label}
            >
              {item.label}
            </button>
          </div>

          <button
            className='breadcrumb-card__status'
            title={item.isApproved ? 'Desmarcar como validado' : 'Marcar como validado'}
            onClick={() =>
              handlerPost({
                migrationId,
                entity: item.entity,
                status: !item.isApproved,
              })
            }
          >
            <StatusCheckIcon isApproved={item.isApproved} />
          </button>
        </div>
      ))}
    </div>
  )
}

export default Breadcrumbs;
